import gql from "graphql-tag";
import qs from "query-string";
import moment from "moment";


export type ShortCargo = {
    id: string
    code: string
    name: string
    description: string
    type: "Контейнер" | "Генеральный груз" | "Насыпной груз",
    label?: string
    status: "Ожидается" | "В порту" | "Убыл" | "Расформирован",
    arrival: {
        date?: string
        document: {
            date: string
            number: string
            type: string
        }
    }
    departure: {
        date?: string
        document: {
            date: string
            number: string
            type: string
        }
    }
    tags: {
        agentRelease: boolean
        customsControl: boolean
        terminalRelease: boolean
    }
    container?: {
        number: string
        type: string
        empty: boolean
    }
};

export type DetailCargo = ShortCargo & {
    operations: {
        date: string
        number: string
        type: string
        description: string
    }[]
}

export const GetCargoListDocument = gql`
    query GetCargos($query: String, $type: String, $page: String, $status: [String], $type: [String], $dateFrom: Date, $dateTo: Date) {
        cargoHistoryCargos(query: $query, type: $type, page: $page, status: $status, type: $type, dateFrom: $dateFrom, dateTo: $dateTo)
        @rest(pathBuilder: $pathBuilder) {
            cargos @type(name: "CargoHistoryCargo") {
                id
                code
                name
                description
                status
                type
                label
                arrival {
                    date
                    document {
                        date
                        number
                        type
                    }
                }
                departure {
                    date
                    document {
                        date
                        number
                        type
                    }
                }
                container {
                    number
                    type
                    weight
                    empty
                }
                tags {
                    agentRelease
                    customsControl
                    terminalRelease
                }
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`

export function getCargoListPathBuilder({args}) {
    const url = "remote/erp/api/v2/cargos";
    const params = {
        offset: "20",
    };
    if (args.query) {
        params["query"] = args.query;
    }
    if (args.type) {
        params["type"] = args.type.join(",");
    }
    if (args.status) {
        params["status"] = args.status.join(",");
    }
    if (args.page) {
        params["page"] = args.page;
    }
    if (args.dateFrom) {
        params["date-from"] = moment(args.dateFrom).format("YYYY-MM-DD");
    }
    if (args.dateTo) {
        params["date-to"] = moment(args.dateTo).format("YYYY-MM-DD");
    }
    return url + "?" + qs.stringify(params);
}

export type GetCargoListQueryVars = {
    type?: ShortCargo["type"][]
    status?: ShortCargo["status"][]
    page?: string
    query?: string
    dateFrom?: number
    dateTo?: number
    pathBuilder: typeof getCargoListPathBuilder
}
export type GetCargoListQueryResult = {
    cargoHistoryCargos: {
        cargos: ShortCargo[]
        pageInfo: {
            countItems: number
            nextPage?: string
            pageSize: number
        }
    }
}


export const GetCargoDetailDocument = gql`
    query GetCargoDetail($id: String!) {
        cargo(id: $id)  @rest(path: "remote/erp/api/v2/cargos/{args.id}") {
            cargo {
                id
                code
                name
                description
                status
                type
                container {
                    number
                    type
                    weight
                    empty
                }
                tags {
                    agentRelease
                    customsControl
                    terminalRelease
                }
                arrival {
                    date
                    document {
                        date
                        number
                        type
                    }
                }
                departure {
                    date
                    document {
                        date
                        number
                        type
                    }
                }
                operations {
                    date
                    number
                    type
                    description
                }
            }
        }
    }
`;
export type GetCargoDetailQueryVars = {
    id: string
}
export type GetCargoDetailQueryResult = {
    cargo: {
        cargo: DetailCargo
    }
}
